import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { Shield, Lock, Mail, Eye, EyeOff, Loader2 } from 'lucide-react'
import './Login.css'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const { login, isLoading } = useAuthStore()
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    const success = await login(email, password)
    if (success) {
      navigate('/')
    }
  }

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Left Side - Branding */}
        <div className="login-branding">
          <div className="branding-content">
            <div className="branding-logo">
              <div className="logo-circle">
                <Shield size={64} />
              </div>
              <h1>GISMAC</h1>
              <p>Security Management System</p>
            </div>
            <div className="branding-features">
              <div className="feature">
                <div className="feature-icon">✓</div>
                <span>Guard Operations & Monitoring</span>
              </div>
              <div className="feature">
                <div className="feature-icon">✓</div>
                <span>Personnel Management</span>
              </div>
              <div className="feature">
                <div className="feature-icon">✓</div>
                <span>Finance & Records</span>
              </div>
              <div className="feature">
                <div className="feature-icon">✓</div>
                <span>Supply Chain Management</span>
              </div>
            </div>
          </div>
          <div className="branding-footer">
            <p>© 2024 Gismac Security. All rights reserved.</p>
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="login-form-section">
          <div className="form-container">
            <div className="form-header">
              <h2>Welcome Back</h2>
              <p>Sign in to your account to continue</p>
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <div className="input-wrapper">
                  <Mail size={20} className="input-icon" />
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    required
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <div className="input-wrapper">
                  <Lock size={20} className="input-icon" />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    required
                    disabled={isLoading}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={isLoading}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>

              <div className="form-options">
                <label className="remember-me">
                  <input type="checkbox" disabled={isLoading} />
                  <span>Remember me</span>
                </label>
                <a href="#" className="forgot-password">Forgot password?</a>
              </div>

              <button 
                type="submit" 
                className="login-btn"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <Loader2 size={20} className="spinner" />
                    Signing in...
                  </>
                ) : (
                  'Sign In'
                )}
              </button>
            </form>

            <div className="demo-credentials">
              <p>Demo Credentials:</p>
              <div className="credentials-grid">
                <div className="credential">
                  <strong>Admin:</strong> admin@gismac.co.ke / admin123
                </div>
                <div className="credential">
                  <strong>HR:</strong> hr@gismac.co.ke / hr123
                </div>
                <div className="credential">
                  <strong>Supervisor:</strong> supervisor@gismac.co.ke / sup123
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
